import * as React from "react";
import { SVGProps } from "react";
const SvgPasswordVisible = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 8c8 0 12 8 12 8l-.003.007-.027.051C27.59 16.78 23.6 24 16 24c-7.6 0-11.59-7.22-11.97-7.942L4 16l.003-.007.027-.051C4.41 15.22 8.4 8 16 8Zm0 2.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Zm0 2a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPasswordVisible;
